import { useState } from 'react';
import { faqs } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
            FAQ
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Quick answers to the most common questions about Sugargoo Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-8">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full shrink-0 transition-all duration-200 ${
                  openIndex === index
                    ? 'bg-primary-100 text-primary-500 rotate-45'
                    : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className="ri-add-line w-4 h-4 flex items-center justify-center"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}